import { AuxiliumComponent } from "../auxilium-component";

export class SortableListItem extends AuxiliumComponent {
	constructor() {
		super();

		this.identifier = this.getAttribute("identifier") ?? "";
	}
}